export const createUserSlice = (set) => ({
  userName: '',
  setUserName: (userName) => {
    set((state) => {
      state.user.userName = userName;
    });
  },
  userId: '',
  setUserId: (userId) => {
    set((state) => {
      state.user.userId = userId;
    });
  },
  setUserInfo: (userInfo) => {
    set((state) => {
      state.user = { ...userInfo };
    });
  },
  resetUserInfo: () => {
    set((state) => {
      state.user = {
        userId: '',
        userName: '',
      };
    });
  },
});

export const createUserAuthListSlice = (set) => ({
  authLists: [],
  setAuthList: (authLists) => {
    set((state) => {
      state.user.authLists = authLists;
    });
  },
});
